export default "__VITE_ASSET__JYmetd5y__"